import { useState, useEffect } from 'react';
import ShopCard from '../home/ShopCard';
import { Filter, ChevronDown, ChevronUp, Edit } from 'lucide-react';
import EditShopImageDialog from './EditShopImageDialog';

// Updated shops data based on provided information
const dummyShops = [
  {
    id: '1',
    name: 'A.S. MOTOR',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-23%20at%2019.40.21_3a0c103d.jpg?updatedAt=1748018844819',
    rating: 4.8,
    reviewCount: 124,
    location: 'Bethlehem, Palestine',
    distance: '1.2 km',
    status: 'open' as const,
    priceRange: '$$$',
    phoneNumber: '0598495018',
  },
  {
    id: '7',
    name: 'Modern Super Clean Station',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-23%20at%2019.33.27_f7c97b57.jpg?updatedAt=1748018778898',
    rating: 4.6,
    reviewCount: 54,
    location: 'Tulkarm, Palestine',
    distance: '2.2 km',
    status: 'open' as const,
    priceRange: '$$',
    phoneNumber: '0592555426',
  },
  {
    id: '14',
    name: 'Al-Mustaqbal',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-26%20at%2018.24.25_ac8fbe95.jpg?updatedAt=1748273196448',
    rating: 4.4,
    reviewCount: 13,
    location: 'Ramallah, Palestine',
    distance: '2.5 km',
    status: 'open' as const,
    priceRange: '$$',
    phoneNumber: '0599722389',
  },
  {
    id: '18',
    name: 'Sara Company for Oils and Filters',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/shops4.jpg?updatedAt=1747427689307',
    rating: 4.2,
    reviewCount: 17,
    location: 'Jenin, Palestine',
    distance: '2.6 km',
    status: 'open' as const,
    priceRange: '$$$',
    phoneNumber: '0595567567',
  },
  {
    id: '10',
    name: 'Dwaikat Station',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-26%20at%2018.24.25_014e4a1f.jpg?updatedAt=1748273196008',
    rating: 4.3,
    reviewCount: 19,
    location: 'Nablus, Palestine',
    distance: '2.9 km',
    status: 'open' as const,
    priceRange: '$$',
    phoneNumber: '0599559108',
  },
  {
    id: '8',
    name: 'Nabil Abu Al-Hassan Garage',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-23%20at%2019.33.27_c8f0862c.jpg?updatedAt=1748018734233',
    rating: 4.5,
    reviewCount: 37,
    location: 'Tulkarm, Palestine',
    distance: '3.4 km',
    status: 'open' as const,
    priceRange: '$',
    phoneNumber: '0599456470',
  },
  {
    id: '3',
    name: 'Al-Okhwa Oil & Filters Trading Co.',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/shops6.jpg?updatedAt=1747427689716',
    rating: 4.5,
    reviewCount: 87,
    location: 'Hebron, Palestine',
    distance: '3.7 km',
    status: 'open' as const,
    priceRange: '$$',
    phoneNumber: '0597896576',
  },
  {
    id: '11',
    name: 'Al-Aamer',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/shops2.jpg?updatedAt=1747427689536',
    rating: 4.1,
    reviewCount: 11,
    location: 'Nablus, Palestine',
    distance: '3.7 km',
    status: 'open' as const,
    priceRange: '$',
    phoneNumber: '0569309999',
  },
  {
    id: '13',
    name: 'SH Auto Dynamic',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-23%20at%2019.33.45_d796ad72.jpg?updatedAt=1748018795934',
    rating: 4.7,
    reviewCount: 20,
    location: 'Qalqilya, Palestine',
    distance: '3.9 km',
    status: 'open' as const,
    priceRange: '$$$',
    phoneNumber: '0598025777',
  },
  {
    id: '15',
    name: 'Al-Aqsa',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-26%20at%2018.24.26_224f770a.jpg?updatedAt=1748273198294',
    rating: 4.0,
    reviewCount: 14,
    location: 'Ramallah, Palestine',
    distance: '4.1 km',
    status: 'open' as const,
    priceRange: '$',
    phoneNumber: '0568600888',
  },
  {
    id: '5',
    name: 'Al-Edra Oil & Filter Co.',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/shops5.jpg?updatedAt=1747427689619',
    rating: 4.4,
    reviewCount: 76,
    location: 'Hebron, Palestine',
    distance: '4.3 km',
    status: 'open' as const,
    priceRange: '$',
    phoneNumber: '0568266024',
  },
  {
    id: '12',
    name: 'Al-Masa',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-26%20at%2018.24.25_3beed088.jpg?updatedAt=1748273199137',
    rating: 4.2,
    reviewCount: 16,
    location: 'Nablus, Palestine',
    distance: '4.4 km',
    status: 'open' as const,
    priceRange: '$$',
    phoneNumber: '0599524703',
  },
  {
    id: '17',
    name: 'Rashad Fakhouri',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-23%20at%2019.33.45_3d87e209.jpg?updatedAt=1748018806486',
    rating: 4.1,
    reviewCount: 8,
    location: 'Jenin, Palestine',
    distance: '4.8 km',
    status: 'open' as const,
    priceRange: '$$',
    phoneNumber: '0569931073',
  },
  {
    id: '4',
    name: 'Mansiya Oil & Filter Shop',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-26%20at%2018.35.58_c8f419de.jpg?updatedAt=1748273767698',
    rating: 4.7,
    reviewCount: 112,
    location: 'Dhahiriya - Hebron, Palestine',
    distance: '5.1 km',
    status: 'open' as const,
    priceRange: '$$$',
    phoneNumber: '0569547070',
  },
  {
    id: '9',
    name: 'Hosni Abu Al-Hassan Station',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-23%20at%2019.35.41_f0267a08.jpg?updatedAt=1748018816969',
    rating: 4.4,
    reviewCount: 23,
    location: 'Tulkarm, Palestine',
    distance: '5.8 km',
    status: 'open' as const,
    priceRange: '$$',
    phoneNumber: '0599757422',
  },
  {
    id: '19',
    name: 'Al-Israa Vehicle Maintenance',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-23%20at%2019.41.57_99829821.jpg?updatedAt=1748018855756',
    rating: 4.0,
    reviewCount: 7,
    location: 'Bethlehem, Palestine',
    distance: '6.8 km',
    status: 'open' as const,
    priceRange: '$$',
    phoneNumber: '0569730730',
  },
  {
    id: '20',
    name: 'Abu Zneid Auto Lube Station',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/WhatsApp%20Image%202025-05-23%20at%2019.38.47_875f4698.jpg?updatedAt=1748018831055',
    rating: 3.9,
    reviewCount: 5,
    location: 'Hebron, Palestine',
    distance: '8.2 km',
    status: 'open' as const,
    priceRange: '$',
    phoneNumber: '0594649383',
  },
  {
    id: '6',
    name: 'Banoura Oil & Filter Shop',
    image: 'https://ik.imagekit.io/b30k93mdj/shops/shops1.jpg?updatedAt=1747427448061',
    rating: 4.2,
    reviewCount: 63,
    location: 'Bethlehem, Palestine',
    distance: '8.9 km',
    status: 'open' as const,
    priceRange: '$$',
    phoneNumber: '0592901308',
  }
];

// Export the shops data so it can be used in ShopProducts.tsx
export { dummyShops };

interface ShopListProps {
  className?: string;
  searchQuery?: string;
}

const ShopList = ({ className = "", searchQuery = "" }: ShopListProps) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filteredShops, setFilteredShops] = useState(dummyShops);
  const [sortBy, setSortBy] = useState('distance');
  const [filterOptions, setFilterOptions] = useState({
    openOnly: false,
    minRating: 0,
    maxPrice: 3, // represents $$$
  });

  // Store edited images in local state
  const [editedImages, setEditedImages] = useState<{ [shopId: string]: string }>({});
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedShopId, setSelectedShopId] = useState<string | null>(null);

  // Priority shops to appear first
  const priorityShopNames = [
    'A.S. MOTOR',
    'Rashad Fakhouri',
    'Al-Okhwa Oil & Filters Trading Co.'
  ];

  // Apply filters whenever searchQuery or filterOptions change
  useEffect(() => {
    let filtered = [...dummyShops];
    
    // Apply search query filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(shop => 
        shop.name.toLowerCase().includes(query) || 
        shop.location.toLowerCase().includes(query)
      );
    }
    
    // Apply other filters
    if (filterOptions.openOnly) {
      filtered = filtered.filter(shop => shop.status === 'open');
    }
    
    if (filterOptions.minRating > 0) {
      filtered = filtered.filter(shop => shop.rating >= filterOptions.minRating);
    }
    
    if (filterOptions.maxPrice < 3) {
      filtered = filtered.filter(shop => shop.priceRange.length <= filterOptions.maxPrice + 1);
    }
    
    // Apply prioritization for the top 3 shops first, then sorting
    const priorityShops = priorityShopNames
      .map(priorityName => filtered.find(shop => shop.name === priorityName))
      .filter(Boolean); // Remove undefined entries
    
    const remainingShops = filtered.filter(shop => !priorityShopNames.includes(shop.name));
    
    // Apply sorting to remaining shops
    if (sortBy === 'distance') {
      remainingShops.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));
    } else if (sortBy === 'rating') {
      remainingShops.sort((a, b) => b.rating - a.rating);
    } else if (sortBy === 'reviews') {
      remainingShops.sort((a, b) => b.reviewCount - a.reviewCount);
    }
    
    // Combine priority shops with sorted remaining shops
    setFilteredShops([...priorityShops, ...remainingShops]);
  }, [searchQuery, filterOptions, sortBy]);

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const handleSortChange = (option: string) => {
    setSortBy(option);
  };

  const handleFilterChange = (
    key: 'openOnly' | 'minRating' | 'maxPrice', 
    value: boolean | number
  ) => {
    setFilterOptions(prev => ({ ...prev, [key]: value }));
  };

  // Edit dialog logic
  const handleOpenEdit = (shopId: string) => {
    setSelectedShopId(shopId);
    setEditDialogOpen(true);
  };

  const handleCloseEdit = () => {
    setEditDialogOpen(false);
    setSelectedShopId(null);
  };

  const handleUpdateImage = (newImage: string) => {
    if (!selectedShopId) return;
    setEditedImages(prev => ({ ...prev, [selectedShopId]: newImage }));
  };

  return (
    <div className={className}>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
        <h2 className="text-2xl font-bold text-autocare-blue">
          {searchQuery ? `Search Results for "${searchQuery}"` : "Oil Change Shops"}
        </h2>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto">
          <div className="relative">
            <button
              onClick={toggleFilter}
              className="flex items-center px-4 py-2 rounded-lg bg-autocare-gray-light text-autocare-blue font-medium hover:bg-autocare-gray-medium transition-colors"
            >
              <Filter className="h-4 w-4 mr-2" />
              Filter
              {isFilterOpen ? <ChevronUp className="ml-2 h-4 w-4" /> : <ChevronDown className="ml-2 h-4 w-4" />}
            </button>
            
            {isFilterOpen && (
              
              <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl z-30 p-4 border border-autocare-gray-medium animate-fade-in">
                <h4 className="font-medium mb-3">Filter Options</h4>
                
                <div className="space-y-4">
                  <div>
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input 
                        type="checkbox" 
                        checked={filterOptions.openOnly} 
                        onChange={(e) => handleFilterChange('openOnly', e.target.checked)}
                        className="rounded text-autocare-blue focus:ring-autocare-blue h-4 w-4"
                      />
                      <span>Open Now Only</span>
                    </label>
                  </div>
                  
                  <div>
                    <label className="block text-sm mb-1">Minimum Rating</label>
                    <select 
                      className="input-field py-1 px-2"
                      value={filterOptions.minRating}
                      onChange={(e) => handleFilterChange('minRating', parseFloat(e.target.value))}
                    >
                      <option value="0">Any Rating</option>
                      <option value="3">3+ Stars</option>
                      <option value="3.5">3.5+ Stars</option>
                      <option value="4">4+ Stars</option>
                      <option value="4.5">4.5+ Stars</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm mb-1">Price Range</label>
                    <select 
                      className="input-field py-1 px-2"
                      value={filterOptions.maxPrice}
                      onChange={(e) => handleFilterChange('maxPrice', parseInt(e.target.value))}
                    >
                      <option value="3">Any Price</option>
                      <option value="2">$$ or less</option>
                      <option value="1">$ only</option>
                    </select>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          <div className="relative">
            <select
              className="py-2 px-4 appearance-none rounded-lg bg-autocare-gray-light text-autocare-blue font-medium w-full"
              value={sortBy}
              onChange={(e) => handleSortChange(e.target.value)}
            >
              <option value="distance">Sort by Distance</option>
              <option value="rating">Sort by Rating</option>
              <option value="reviews">Sort by Most Reviews</option>
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <ChevronDown className="h-4 w-4" />
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredShops.map((shop) => (
          <div key={shop.id} className="relative group">
            <ShopCard
              shop={{
                ...shop,
                image: editedImages[shop.id] || shop.image,
                phoneNumber: shop.phoneNumber,
              }}
            />
            
          </div>
        ))}
      </div>

      {filteredShops.length === 0 && (
        <div className="text-center py-12">
          <h3 className="text-xl font-medium mb-2">No shops match your filters</h3>
          <p className="text-gray-600">Try adjusting your search or filters to see more results</p>
        </div>
      )}

      {/* Edit Shop Image Dialog (only open when editing) */}
      {selectedShopId && (
        <EditShopImageDialog
          open={editDialogOpen}
          onClose={handleCloseEdit}
          currentImage={
            editedImages[selectedShopId] ||
            (dummyShops.find(s => s.id === selectedShopId)?.image || '')
          }
          onChangeImage={handleUpdateImage}
        />
      )}
    </div>
  );
};

export default ShopList;
